import * as React from "react"
import { License } from "types/transaction"
import Typography from "components/typography"

const ProductLicense: React.FC<{ license: License[] }> = ({ license }) => {
	return (
		<>
			{license.map((product) => (
				<React.Fragment key={product.id}>
					<Typography gutterBottom>{product.name}</Typography>
					<Typography gutterBottom>
						لایسنس: <strong>{product.license}</strong>
					</Typography>
				</React.Fragment>
			))}
		</>
	)
}

export default ProductLicense
